import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/frontend/src/components/yachts/YachtsBottomNav.tsx");
